import type {
  ForumPostState,
  ForumVote,
  ForumComposeComment,
  ForumCommentDeletion,
  ForumImageShare,
  ForumMarkdownRenderer,
  ForumCommentVoteHandler,
  ForumCommentRecord,
  ForumLinkRenderer,
} from "../forum.types";
import { RefreshFeedback } from "../forum-refresh-feedback";
import { ForumPostArticle } from "./forum-post-article";
import { ForumPostImageShare } from "./forum-post-image-share";
import { ForumPostComments } from "../comments/forum-post-comments";
function countComments(comments: readonly ForumCommentRecord[]): number {
  return comments.reduce(
    (count, comment) => count + 1 + countComments(comment.replies),
    0,
  );
}
export function ForumPostContent({
  state,
  layout,
  postVote,
  onPostVote,
  shareImage,
  name,
  renderLink,
  renderMarkdown,
  commentVotes,
  onCommentVote,
  deleteComment,
  compose,
  onRefresh,
}: Readonly<{
  state: Extract<ForumPostState, Readonly<{ status: "ready" }>>;
  layout: "page" | "embedded";
  postVote: ForumVote | undefined;
  onPostVote(direction: 1 | -1): void;
  shareImage: ForumImageShare | undefined;
  name: string;
  renderLink: ForumLinkRenderer;
  renderMarkdown: ForumMarkdownRenderer;
  commentVotes: Readonly<Record<string, ForumVote>> | undefined;
  onCommentVote: ForumCommentVoteHandler;
  deleteComment: ForumCommentDeletion | undefined;
  compose: ForumComposeComment | undefined;
  onRefresh(): void;
}>) {
  const commentCount =
    state.comments.status === "ready"
      ? countComments(state.comments.records)
      : state.post.commentCount;
  return (
    <>
      <RefreshFeedback
        refreshing={state.refreshing}
        error={state.refreshError}
        onRefresh={onRefresh}
      />
      <ForumPostArticle
        post={state.post}
        layout={layout}
        postVote={postVote}
        onPostVote={onPostVote}
        shareImage={shareImage}
        name={name}
        renderLink={renderLink}
        renderMarkdown={renderMarkdown}
        commentCount={commentCount}
      />
      {shareImage && state.post.content.format !== "deleted" && (
        <ForumPostImageShare shareImage={shareImage} />
      )}
      <ForumPostComments
        state={state.comments}
        commentCount={commentCount}
        onRefresh={onRefresh}
        commentVotes={commentVotes}
        onCommentVote={onCommentVote}
        renderMarkdown={renderMarkdown}
        renderLink={renderLink}
        deleteComment={deleteComment}
        compose={compose}
      />
    </>
  );
}
